import React from 'react';
import styled from 'styled-components';
import { fadeIn } from './styled';

const ProfileMenuContainer = styled.div`
  position: absolute;
  top: 56px;
  right: 0;
  width: 220px;
  background: rgba(15, 23, 42, 0.95);
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 14px;
  box-shadow: 0 20px 45px rgba(1, 6, 17, 0.55);
  backdrop-filter: blur(14px);
  padding: 8px 0;
  animation: ${fadeIn} 0.25s ease both;
  overflow: hidden;
  z-index: 100002;

  @media (max-width: 576px) {
    right: -16px;
  }
`;

const ProfileMenuItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  background: transparent;
  border: none;
  color: #e5e7eb;
  font-size: 0.9rem;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s ease, padding-left 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    padding-left: 22px;
  }

  &:focus-visible {
    outline: 2px solid #00f7d2;
    outline-offset: -2px;
  }
`;

const ProfileMenuDivider = styled.div`
  height: 1px;
  margin: 6px 0;
  background: rgba(255, 255, 255, 0.08);
`;

const ProfileMenuIcon = styled.i`
  font-size: 1rem;
  opacity: 0.8;
`;

const ProfileMenu = ({ menuItems, menuRef }) => (
  <ProfileMenuContainer ref={menuRef}>
    {menuItems.map((item, index) => {
      if (item.type === 'divider') {
        return <ProfileMenuDivider key={`divider-${index}`} />;
      }
      return (
        <ProfileMenuItem
          key={item.label}
          type="button"
          onClick={item.action}
        >
          <ProfileMenuIcon className={`lnr lnr-${item.icon}`} />
          <span>{item.label}</span>
        </ProfileMenuItem>
      );
    })}
  </ProfileMenuContainer>
);

export default ProfileMenu;

